// Exportación CSV del tablero de alertas de completitud en vivo (H-023 de la
// auditoría 2026-10: "exportación de respaldo del tablero"). Se genera EN EL NAVEGADOR
// con las alertas que el servidor ya devolvió al administrador (el servidor aplica el
// alcance por sede), así que no abre una vía nueva de lectura. Sin dependencias.
import { TITULO_POR_ITEM } from './pasosCalidadHc';
import type { AlertaViva } from './calidadHc';

/**
 * Una celda CSV segura: siempre entre comillas, comillas duplicadas, y NEUTRALIZADA ante
 * inyección de fórmulas en Excel/Sheets (un valor que empieza con `=`, `+`, `-`, `@`, tab o
 * retorno de carro se interpretaría como fórmula): se antepone `'`. Los nombres de paciente y
 * de profesional vienen de datos que escribe cualquiera con acceso al HCE.
 */
export function celdaCsv(valor: unknown): string {
  let texto = valor === null || valor === undefined ? '' : String(valor);
  if (/^[=+\-@\t\r]/.test(texto)) texto = `'${texto}`;
  return `"${texto.replace(/"/g, '""')}"`;
}

export const ENCABEZADO_CSV_ALERTAS = ['Paciente', 'Qué falta', 'Código', 'Último profesional', 'Fecha', 'Consulta'] as const;

/** CSV (UTF-8, con BOM para que Excel respete las tildes; saltos CRLF) de la lista de alertas, tal como la ve el administrador. */
export function alertasACsv(alertas: readonly AlertaViva[]): string {
  const filas = alertas.map((a) =>
    [a.patientName, TITULO_POR_ITEM[a.clave] ?? a.clave, a.clave, a.practitionerName ?? '', a.fecha ?? '', a.encounterRef].map(celdaCsv).join(','),
  );
  return `﻿${[ENCABEZADO_CSV_ALERTAS.map(celdaCsv).join(','), ...filas].join('\r\n')}\r\n`;
}

/** Nombre de archivo con la fecha de generación (sin datos del paciente). */
export function nombreArchivoCsvAlertas(slug: string, ahora: Date = new Date()): string {
  const limpio = slug.replace(/[^a-zA-Z0-9-]/g, '') || 'consultorio';
  return `alertas-completitud-${limpio}-${ahora.toISOString().slice(0, 10)}.csv`;
}

/** Dispara la descarga en el navegador. */
export function descargarCsv(nombre: string, contenido: string): void {
  const url = URL.createObjectURL(new Blob([contenido], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revocar de inmediato puede cancelar la descarga en algunos navegadores: se difiere.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
